import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import { useSelector } from "react-redux";
import {
  GetAsoComparisonByClientId,
  GetExperienceComparisonByClientId,
  GetRateReviewReports,
  GetRenewalComparisonByClientId,
} from "../../../../api/User/ACG/FinalACGRateReviewApi";
import Fontstyling from "../../../../components/common/comman";
import { Button, Modal, Spinner } from "react-bootstrap";
import toastFile from "../../../../Service/ToastFile";

const FinalACGRateReview = () => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [data, setData] = useState({ renewal: [], experience: [], ASO: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerate, setisGenerate] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");

  const overrideColumn1 = [
    {
      title: "Client ID",
      field: "client_ID",
    },
    {
      title: "Carrier",
      field: "carrier",
    },
    {
      title: "Plan Name",
      field: "plan_Name",
    },
    {
      title: "Tier",
      field: "tier",
    },
    {
      title: "Enrollment",
      field: "enrollment",
    },
    {
      title: "Current",
      field: "currRate",
    },
    {
      title: "Renewal",
      field: "renewalRate",
    },
    {
      title: "ACG F/I",
      field: "acgRate",
    },
  ];
  const overrideColumn2 = [
    {
      title: "Client ID",
      field: "client_ID",
    },
    {
      title: "Carrier",
      field: "carrier",
    },
    {
      title: "Plan Name",
      field: "plan_Name",
    },
    {
      title: "Tier",
      field: "tier",
    },
    {
      title: "Enrollment",
      field: "ct",
    },
    {
      title: "Current",
      field: "currRate",
    },
    {
      title: "Renewal",
      field: "renewalRate",
    },
    {
      title: "ACG XP",
      field: "overRideACGRate",
    },
  ];
  const overrideColumn3 = [
    {
      title: "Client ID",
      field: "client_ID",
    },
    {
      title: "Carrier",
      field: "carrier",
    },
    {
      title: "Plan Name",
      field: "plan_Name",
    },
    {
      title: "Tier",
      field: "tier",
    },
    {
      title: "Enrollment",
      field: "ct",
    },
    {
      title: "Current",
      field: "currRate",
    },
    {
      title: "Renewal",
      field: "renewalRate",
    },
    {
      title: "Baseline ASO",
      field: "asO_Rate",
    },
  ];

  useEffect(() => {
    getData();
  }, [client?.clientID]);

  const getData = () => {
    setIsLoading(true);
    GetRenewalComparisonByClientId(client?.clientID)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData((prev) => ({ ...prev, renewal: res.data }));
        }
      })
      .catch((err) => console.log({ err }));
    GetExperienceComparisonByClientId(client?.clientID)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData((prev) => ({ ...prev, experience: res.data }));
        }
      })
      .catch((err) => console.log({ err }));
    GetAsoComparisonByClientId(client?.clientID, user.UD_id)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData((prev) => ({ ...prev, ASO: res.data }));
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleclick = () => {
    if (
      client === null ||
      client?.clientID === null ||
      client?.clientID === 0
    ) {
      toastFile("Select Client");
      return;
    }
    GetRateReviewReports(client?.clientID, 1, user.UD_id).then((res) => {
      if (res.data.success) {
        setMessage(
          "Some Carriers and plans have Renewal Increase rate of 0%. Do you want to proceed?"
        );
        setShowModal(true);
      } else {
        // setMessage("Have you completed the Underwriting Adjustments?");
        // setShowModal(true);
        setisGenerate(true);
        GetRateReviewReports(client?.clientID, 2, user.UD_id)
          .then((res) => {
            if (res.data.success) {
              toastFile("new");
              getData();
              setMessage("");
            } else {
              setMessage("");
              toastFile("something wrong");
            }
          })
          .finally((res) => setisGenerate(false));
      }
    });
  };

  return (
    <div>
      <Modal show={showModal} aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              setShowModal(false);
              setisGenerate(true);
                GetRateReviewReports(client?.clientID, 2, user.UD_id)
                  .then((res) => {
                    if (res.data.success) {
                      toastFile("new");
                      getData();
                      setMessage("");
                    } else {
                      setMessage("");
                      toastFile("something wrong");
                    }
                  })
                  .finally((res) => setisGenerate(false));
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setShowModal(false);
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="text-end">
        <button
          style={Fontstyling.addnewbutton}
          onClick={handleclick}
          disabled={isGenerate}
        >
          {isGenerate ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="false"
                style={{ marginRight: "5px" }}
              />
              <span>Generate Final ACG Rate Review Report</span>
            </div>
          ) : (
            "Generate Final ACG Rate Review Report"
          )}
        </button>
      </div>
      <div className="mt-4"></div>
      <CustomMaterialTable
        title={
          "ACG Benchmark Rating Analysis: Current and Renewal Comparison Analysis"
        }
        overrideColumn={overrideColumn1}
        data={data.renewal}
        isLoading={isLoading}
        isExport={false}
      />
      <div className="mt-4 border-top"></div>
      <CustomMaterialTable
        title={
          "ACG Benchmark Rating Analysis: Current and Experience Comparison Analysis"
        }
        overrideColumn={overrideColumn2}
        data={data.experience}
        isLoading={isLoading}
        isExport={false}
      />
      <div className="mt-4 border-top"></div>
      {/* <CustomMaterialTable
        title={
          "ACG Benchmark Rating Analysis: Current and ASO Comparison Analysis"
        }
        overrideColumn={overrideColumn3}
        data={data.ASO}
        isLoading={isLoading}
        isExport={false}
      /> */}
    </div>
  );
};

export default FinalACGRateReview;
